<ion-content [fullscreen]="true" class="viva-page control-container">
  <div class="page-with-watermark">
    <div class="background-gradient"></div>

    <main id="page-main" class="layout-page-container">
      <div class="top-section">
        <h1>{{ 'pn-intro-component.slogan.line1' | translate }}</h1>
        <h1>{{ 'pn-intro-component.slogan.line2' | translate }}</h1>
        <h1>{{ 'pn-intro-component.slogan.line3' | translate }}</h1>
      </div>

      <div class="bottom-section">
        <div class="buttons">
          <ion-row *ngIf="enableRegistration">
            <ion-col>
              <ion-button class="btn-width" (click)="getStarted()" color="dark" [disabled]="!environmentReady">
                {{ 'pn-intro-component.buttons.get-started' | translate }}
              </ion-button>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col>
              <ion-button class="btn-width" (click)="login()" color="primary" [disabled]="!environmentReady">
                {{ 'pn-intro-component.buttons.login' | translate }}
              </ion-button>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="scanFriendAllowed">
            <ion-col>
              <ion-button class="btn-width" (click)="vivaLite()" color="dark" [disabled]="!environmentReady">
                {{ 'pn-intro-component.buttons.viva-lite' | translate }}
              </ion-button>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col>
              <small class="powered-by-vivascore">{{ 'pn-intro-component.by-vivascore' | translate }}</small>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </main>
  </div>
</ion-content>
